import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
import { linkMixin, linkDisabledMixin, linkUseColorsMixin } from "../Link.mixins";
export var styles = memoizeStyle({
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      ", ";\n      position: relative;\n    "])), linkMixin(t.linkHoverTextDecoration));
  },
  button: function button(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      line-height: ", ";\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), t.linkButtonLineHeight, t.linkButtonPaddingX, t.linkButtonPaddingX);
  },
  buttonOpened: function buttonOpened() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      background: #e1e1e1;\n    "])));
  },
  arrow: function arrow() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      border: 4px solid transparent;\n      border-bottom-width: 0;\n      border-top-color: #a0a0a0;\n      display: inline-block;\n      margin-bottom: 3px;\n      margin-left: 3px;\n      vertical-align: middle;\n    "])));
  },
  useDefault: function useDefault(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), linkUseColorsMixin(t.linkColor, t.linkHoverColor, t.linkActiveColor));
  },
  useSuccess: function useSuccess(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), linkUseColorsMixin(t.linkSuccessColor, t.linkSuccessHoverColor, t.linkSuccessActiveColor));
  },
  useDanger: function useDanger(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), linkUseColorsMixin(t.linkDangerColor, t.linkDangerHoverColor, t.linkDangerActiveColor));
  },
  useGrayed: function useGrayed(t) {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), linkUseColorsMixin(t.linkDisabledColor, t.linkDisabledColor, t.linkDisabledColor));
  },
  useGrayedFocus: function useGrayedFocus(t) {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.linkDisabledColor);
  },
  focus: function focus(t) {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n      text-decoration: ", ";\n    "])), t.linkHoverTextDecoration);
  },
  disabled: function disabled(t) {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n      ", ";\n\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), linkDisabledMixin(), t.linkDisabledColor, t.linkDisabledColor);
  },
  icon: function icon(t) {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      margin-right: ", ";\n    "])), t.linkIconMarginRight);
  }
});